import { useEffect, useState } from 'react';
import axios from 'axios';

export const useUHF = () => {
    const [cssIncludes, setCssIncludes] = useState([]);
    const [javascriptIncludes, setJavascriptIncludes] = useState([]);
    const [headerHtml, setHeaderHtml] = useState(null);
    const [footerHtml, setFooterHtml] = useState(null);
    const [error, setError] = useState(null);

    const parse = (document, selector) => {
        const element = document.querySelector(selector);
        const string = element?.firstChild?.wholeText?.trim();

        const parser = new DOMParser();
        const html = parser.parseFromString(string, 'text/html');

        return html;
    };

    const parseCssIncludes = (document) => {
        const linksParsed = parse(document, 'cssIncludes');
        const linksItems = linksParsed.querySelectorAll('link');

        const links = [];
        for (const link of linksItems) {
            links.push({
                href: link.href,
                type: link.type,
                media: link.media,
                rel: link.rel,
            });
        }

        setCssIncludes(links);
    };

    const parseJavascriptIncludes = (document) => {
        const scriptsParsed = parse(document, 'javascriptIncludes');
        const scriptsItems = scriptsParsed.querySelectorAll('script');

        const scripts = [];
        for (const link of scriptsItems) {
            scripts.push({
                src: link.src,
            });
        }

        setJavascriptIncludes(scripts);
    };

    const parseHeaderHtml = (document) => {
        const html = parse(document, 'headerHtml');

        setHeaderHtml(html?.body?.innerHTML);
    };

    const parseFooterHtml = (document) => {
        const html = parse(document, 'footerHtml');

        setFooterHtml(html?.body?.innerHTML);
    };

    //

    useEffect(() => {
        const url = new URL(
            'https://uhf.microsoft.com/en-us/shell/xml/MSUnlocked/'
        );
        url.searchParams.append('headerId', 'MSUnlockedHeader');
        url.searchParams.append('footerId', 'MSUnlockedFooter');
        url.searchParams.append('preview', '0');
        url.searchParams.append('CookieComplianceEnabled', 'false');

        const controller = new AbortController();

        //

        const config = { url: url.href, signal: controller.signal };

        axios(config)
            .then((response) => {
                const xml = response.data;
                const parser = new DOMParser();
                const document = parser.parseFromString(xml, 'application/xml');

                console.log('debug.uhf', document);

                parseCssIncludes(document);
                parseJavascriptIncludes(document);
                parseHeaderHtml(document);
                parseFooterHtml(document);
            })
            .catch((error) => {
                console.log('debug.uhf', error, error?.response);

                if (error?.code === 'ERR_CANCELED') return;

                setError({
                    code: error?.code,
                    message: error?.message,
                    name: error?.name,
                });
            });

        return () => {
            controller.abort();
        };
    }, []);

    //

    return {
        cssIncludes,
        javascriptIncludes,
        headerHtml,
        footerHtml,
        error,
    };
};
